module.exports = __webpack_public_path__ + "static/media/profileAvatar.606f952b.png";